import { Icon } from 'antd';
import React from 'react';
import * as S from './styles';
import { getStatusIcon, getStatusMessage } from '../../../../../utils/helper';
import { useTranslation } from 'react-i18next';

const BatchDetailsHeader = ({ batch, handleCancel }) => {
    const { t } = useTranslation();
    return (
        <S.Header>
            <S.TitleContainer>
                <div className="title-container">
                    <h4 title={batch?.batchName}>{batch?.batchName}</h4>
                    {getStatusIcon(batch?.status?.trim())}
                    <p>{getStatusMessage(batch?.status?.trim(), t)}</p>
                </div>
                {/* <S.Title>{batch?.name}</S.Title> */}
                {/* {batch?.status === 'draft' ? (
                    <S.Badge bgColor="#f3e8ff">
                        <Icon type="edit" style={{ color: '#9c179e', fontSize: '14px' }} />
                        <S.BadgeText color="#9c179e">DRAFT</S.BadgeText>
                    </S.Badge>
                ) : batch?.status === 'pending_approval' ? (
                    <S.Badge bgColor="rgba(147, 51, 234, 0.1)">
                        <Icon type="clock-circle" style={{ color: '#9333ea', fontSize: '14px' }} />
                        <S.BadgeText color="#9333ea">PENDING APPROVAL</S.BadgeText>
                    </S.Badge>
                ) : (
                    <S.StatusBadge status={batch?.status}>
                        <S.StatusIndicator status={batch?.status} />
                        <S.StatusText status={batch?.status}>
                            {batch?.status === 'completed' ? 'COMPLETED' :
                                batch?.status === 'running' ? 'RUNNING' :
                                    batch?.status === 'scheduled' ? 'SCHEDULED' : 'PENDING'}
                        </S.StatusText>
                    </S.StatusBadge>
                )} */}
            </S.TitleContainer>
            {/* {(batch?.status === 'scheduled' || batch?.status === 'running') && (
                <S.CancelButton onClick={handleCancel}>
                    <Icon type="close-circle" />
                    Cancel Job
                </S.CancelButton>
            )} */}
        </S.Header>
    );
};

export default BatchDetailsHeader;
